import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldOff, ArrowLeft } from 'lucide-react';

const Unauthorized: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '40px'
    }}>
      <div style={{
        width: '120px',
        height: '120px',
        borderRadius: '50%',
        backgroundColor: 'var(--color-red)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '32px',
        opacity: 0.1
      }}>
        <ShieldOff size={60} color="var(--color-red)" />
      </div>

      <h1 style={{
        fontSize: 'var(--font-size-32)',
        fontWeight: 700,
        color: 'var(--color-dimgray)',
        marginBottom: '16px'
      }}>
        Acesso Negado
      </h1>

      <p style={{
        fontSize: 'var(--font-size-18)',
        color: 'var(--color-darkgray)',
        marginBottom: '32px',
        maxWidth: '500px',
        lineHeight: 1.5
      }}>
        Você não possui permissão para acessar esta página. Entre em contato com o administrador 
        do sistema se acredita que isso é um erro.
      </p>

      <Link to="/dashboard" className="btn btn-primary">
        <ArrowLeft size={20} />
        Voltar ao Dashboard
      </Link>
    </div>
  );
};

export default Unauthorized;